import React from "react";
import "./Header.css";

export default function Header(props) {
  const { rest, lang } = props;

  const renderFlags = () => {
    return rest.langs.map((flag, index) => {
      return (
        <div
          key={index}
          className={lang === flag ? "lang selected" : "lang"}
          onClick={() => props.onChangeLang(flag)}
        >
          <img src={`img/country_flags/${flag}.svg`} alt={`flag ${flag}`} />
        </div>
      );
    });
  };

  return (
    <div
      className="header"
      style={{ backgroundImage: `url("/img/headers/${rest.headerPic}")` }}
    >
      <div className="title">{rest.name}</div>
      <div className="langs-wrapper">{renderFlags()}</div>
    </div>
  );
}
